import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import moment from "moment";
import AOS from "aos";

import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

// Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(new Date(value)).format("YYYY/MM/DD hh:mm:ss");
  }
});

Vue.filter("formatDates", function (value) {
  if (value) {
    return moment(new Date(value)).format("hh:mm:ss");
  }
});

Vue.filter("formatDateo", function (value) {
  if (value) {
    return moment(new Date(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatDatet", function (value) {
  if (value) {
    return moment(new Date(value)).format("hh:mm");
  }
});

Vue.filter("formatDateNew", function (value) {
  if (value) {
    return moment(new Date(value)).format("YYYY-MM-DD hh:mm:ss");
  }
});

Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
